import { createContext, useContext, useState, useEffect } from "react";
import en from "../i18n/en.json";
import es from "../i18n/es.json";

const translations = { en, es };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("curious123_lang");
    if (saved) return saved;
    const browserLang = navigator.language || navigator.userLanguage || "en";
    return browserLang.startsWith("es") ? "es" : "en";
  });

  useEffect(() => {
    localStorage.setItem("curious123_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.en;
  const toggle = () => setLang(lang === "en" ? "es" : "en");

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
